<template>
    <div class="flex flex-col gap-1 text-xs leading-none">
        <div class="flex flex-row items-center gap-2">
            <MailIcon class="size-3.5 shrink-0 text-gray-500" />
            <span class="text-gray-600 font-normal">{{ props.email }}</span>
        </div>
        <div v-if="showPasswordHint" class="flex flex-row items-center gap-2">
            <PasswordIcon class="size-3.5 shrink-0 text-gray-500" />
            <span class="tracking-widest text-gray-500 font-normal">{{ '•'.repeat(12) }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import MailIcon from '../Icon/MailIcon.vue';
import PasswordIcon from '../Icon/PasswordIcon.vue';

type CredentialsInfoProps = {
    email: string;
    showPasswordHint: boolean;
};

const props = defineProps<CredentialsInfoProps>();
</script>
